
export const PATTERN_ROAD_ID = 'pattern--road';

export const PatternRoad: React.FC = () => (
  <pattern id={PATTERN_ROAD_ID} patternUnits="userSpaceOnUse" width={355} height={549}>
    <path fill="#c9a164" d="M0 0H355V549H0z" />
    <path
      fill="#c9a164"
      stroke="#77964a"
      strokeWidth="10"
      d="M355 5L0 5"
    />
    <path
      fill="#c9a164"
      stroke="#77964a"
      strokeWidth="10"
      d="M0 544.14L355 544.14"
    />
    <path fill="gray" d="M0 35H355V505H0z" />
    <path
      fill="none"
      stroke="#e6e6e6"
      strokeLinecap="round"
      strokeWidth="14"
      d="M8 246L125.04 246"
    />
  </pattern>
);
